// Orenza Money primitive — every rupee amount renders through this.
// Indian comma grouping + JetBrains Mono tabular + Cobalt for "important" + Crimson parenthesised for negatives.

import { cn } from '@/lib/cn';
import { formatINR, formatINRDelta } from '@/utils/format';

export interface MoneyProps {
  amount: number | string | null | undefined;
  important?: boolean; // Cobalt + larger weight
  decimals?: number;
  signed?: boolean;
  className?: string;
}

export function Money({ amount, important, decimals, signed, className }: MoneyProps) {
  const text = formatINR(amount, { decimals, signed });
  const isNeg = typeof amount === 'number' ? amount < 0 : Number(amount) < 0;
  return (
    <span
      data-numeric
      className={cn(
        'font-mono tabular-nums',
        important && 'text-cobalt font-medium',
        isNeg && 'text-crimson',
        className,
      )}
    >
      {text}
    </span>
  );
}

export interface DeltaProps {
  amount: number | null | undefined;
  className?: string;
}

export function Delta({ amount, className }: DeltaProps) {
  const { text, tone } = formatINRDelta(amount);
  return (
    <span
      data-numeric
      className={cn(
        'font-mono tabular-nums text-micro',
        tone === 'positive' && 'text-emerald',
        tone === 'negative' && 'text-crimson',
        tone === 'neutral' && 'text-cool',
        className,
      )}
    >
      {text}
    </span>
  );
}
